import React, { useEffect, useState } from 'react'
import styles from './index.module.sass'
import { useNavigate, useParams } from 'react-router-dom'
import classNames from 'classnames'
import prev from '../../../assets/arrow_prev.svg'
import next from '../../../assets/arrow_next.svg'
import { Search } from '../../ui/Search'
import { SearchItems } from './SearchItems'
import { getResults, ResultList } from '../../../services/SearchResultsPage'
import { Icon } from '../../ui/Icon'
import {DomainNameItems} from '../AddressPage/DomainNameItems'
import { TransactionList } from '../../../services/TransactionsPageService'

const previousParams: Record<string, string>[] = []
let currentParams: Record<string, string> = {}
let page = 1

export const SearchResultsPage = () => {
    const navigate = useNavigate()
    const [transactions, setTransactions] = useState<TransactionList>({
        items: [],
        next_page_params: null,
    })
    const { query } = useParams()
    const [results, setResults] = useState<ResultList>({
        items: [],
        next_page_params: null,
    })
    useEffect(() => {
        getResults(setResults, query, {}, navigate)
    }, [])

    const isDisabled = page == 1
    const previousPageHandler = () => {
        if (previousParams.length > 0) {
            page = page - 1
            currentParams = previousParams.pop() || {}
            getResults(setResults, query, currentParams, navigate)
        }
    }
    const nextPageHandler = () => {
        if (results.next_page_params) {
            previousParams.push(currentParams)
            currentParams = results.next_page_params
            page = page + 1
            getResults(setResults, query, currentParams, navigate)
        }
    }
    const resultsCounter =
        results.items.length != 0
            ? results.next_page_params
                ? '50+'
                : results.items.length
            : 0
    return (
        <div className={styles.pageSection}>
            {/* <div className={styles.subselection}>
                <h1 className={styles.welcome}>
                    DomainName Lookup
                </h1>
                <section className={styles.searchSection}>
                    <Search />
                </section>
                <h1 className={styles.subwelcome}>
                    Domain names allow users to interact with other addresses on-chain using human-readable names instead of long and complicated address hashes.
                </h1>
            </div>
            <div className={styles.searchnamesection}>
                Results for migo.eth
            </div>
            <div className={styles.blockdetail}>
                <div className={styles.details}>
                    <div className={styles.infoRow}>
                        Overview of ENS
                    </div>
                    <div className={styles.infoRow}>
                        <span>
                            <Icon icon="infoSVG" width={24} height={24} color={"white"}/>
                        </span>
                        <p className={styles.rowTitle}>Resolved Address: </p>
                        <p>0xAb6fd6074782C805933d030e80129155a2156D94</p>
                    </div>
                    <div className={styles.infoRow}>
                        <span>
                            <Icon icon="infoSVG" width={24} height={24} color={"white"}/>
                        </span>
                        <p className={styles.rowTitle}>Expiration Date: </p>
                        <p>2024.08.12 at 08:07</p>
                    </div>
                    <div className={styles.infoRow}>
                        <span>
                            <Icon icon="infoSVG" width={24} height={24} color={"white"}/>
                        </span>
                        <p className={styles.rowTitle}>Resolved Address: </p>
                        <p>0xD4416b13d2b3a9aBae7AcD5D6C2BbDBE25686401</p>
                    </div>
                    <div className={styles.infoRow}>
                        <span>
                            <Icon icon="infoSVG" width={24} height={24} color={"white"}/>
                        </span>
                        <p className={styles.rowTitle}>Controller: </p>
                        <p>0xD4416b13d2b3a9aBae7AcD5D6C2BbDBE25686401</p>
                    </div>
                    <div className={styles.infoRow}>
                        <span>
                            <Icon icon="infoSVG" width={24} height={24} color={"white"}/>
                        </span>
                        <p className={styles.rowTitle}>Token ID: </p>
                        <p>43850163491295005991985967203796268158046837432750697189247115978258759</p>
                    </div>
                </div>
                            <div className={styles.transactions}>
                                
                                <div className={styles.tableWrapper}>
                                    <table className={styles.table}>
                                        <thead>
                                            <tr>
                                                <th className={styles.paddingitem}>
                                                    Transaction
                                                    <span> </span>
                                                    <Icon icon='dynamicarrow' width={10} height={12} color='white'></Icon>
                                                </th>
                                                <th className={styles.paddingitem}>
                                                    Age
                                                    <span> </span>
                                                    <Icon icon='dynamicarrow' width={10} height={12} color='white'></Icon>
                                                </th>
                                                <th className={styles.paddingitem}>
                                                    From
                                                    <span> </span>
                                                    <Icon icon='dynamicarrow' width={10} height={12} color='white'></Icon>
                                                </th>
                                                
                                                <th className={styles.paddingitem}>
                                                    Action
                                                    <span> </span>
                                                    <Icon icon='dynamicarrow' width={10} height={12} color='white'></Icon>
                                                </th>
                                            </tr>
                                        </thead>
                                        <thead>
                                            <tr>
                                                <th className={styles.paddingitem}>
                                                    0xc08c...e4f
                                                </th>
                                                <th className={styles.paddingitem}>
                                                   1 hr 31 mins ago
                                                </th>
                                                <th className={styles.paddingitem}>
                                                   0xc08c...e4f
                                                </th>
                                                <th className={styles.paddingitem}>
                                                    setSubnodeRecord
                                                </th>
                                            </tr>
                                        </thead>
                                        <thead>
                                            <tr>
                                                <th className={styles.paddingitem}>
                                                    0xc08c...e4f
                                                </th>
                                                <th className={styles.paddingitem}>
                                                   1 hr 31 mins ago
                                                </th>
                                                <th className={styles.paddingitem}>
                                                   0xc08c...e4f
                                                </th>
                                                <th className={styles.paddingitem}>
                                                    setSubnodeRecord
                                                </th>
                                            </tr>
                                        </thead>
                                        <thead>
                                            <tr>
                                                <th className={styles.paddingitem}>
                                                    0xc08c...e4f
                                                </th>
                                                <th className={styles.paddingitem}>
                                                   1 hr 31 mins ago
                                                </th>
                                                <th className={styles.paddingitem}>
                                                   0xc08c...e4f
                                                </th>
                                                <th className={styles.paddingitem}>
                                                    setSubnodeRecord
                                                </th>
                                            </tr>
                                        </thead>
                                        <thead>
                                            <tr>
                                                <th className={styles.paddingitem}>
                                                    0xc08c...e4f
                                                </th>
                                                <th className={styles.paddingitem}>
                                                   1 hr 31 mins ago
                                                </th>
                                                <th className={styles.paddingitem}>
                                                   0xc08c...e4f
                                                </th>
                                                <th className={styles.paddingitem}>
                                                    setSubnodeRecord
                                                </th>
                                            </tr>
                                        </thead>
                                    </table>
                                </div>
                            </div>
            </div> */}
            <div className={styles.headOfPage}>
                <p>Search results</p>
            </div>
            <p className={styles.resultCount}>
                Found {resultsCounter} matching{' '}
                {resultsCounter == 1 ? 'result' : 'results'} for “{query}”
            </p>
            {resultsCounter && (
                <div className={styles.transactions}>
                    <div className={styles.paginationButtons}>
                        <button
                            className={styles.controlButton}
                            disabled={isDisabled}
                            onClick={previousPageHandler}>
                            <img src={prev} alt="previous page" />
                        </button>
                        <div className={styles.pageNum}>{page}</div>
                        <button
                            className={styles.controlButton}
                            disabled={!results.next_page_params}
                            onClick={nextPageHandler}>
                            <img src={next} alt="next page" />
                        </button>
                    </div>
                    <div className={styles.tableWrapper}>
                        <div className={styles.tableBorder}></div>
                        <table className={styles.table}>
                            <thead className={styles.tableHead}>
                                <tr>
                                    <th
                                        className={classNames(
                                            styles.th40,
                                            styles.thDefault
                                        )}>
                                        Search result
                                    </th>
                                    <th
                                        className={classNames(
                                            styles.thW40,
                                            styles.thDefault
                                        )}></th>
                                    <th
                                        className={classNames(
                                            styles.thW20,
                                            styles.thDefaultRight
                                        )}>
                                        Type
                                    </th>
                                </tr>
                            </thead>
                            <SearchItems
                                SearchArray={results.items}></SearchItems>
                        </table>
                    </div>
                </div>
            )}
        </div>
    )
}
